/** Per-market colour, shared by the Win the Day pages.
 *
 * A market with no score is still a market: painting those tiles plain white
 * left the Executive grid almost entirely black-and-white, and made the eight
 * markets indistinguishable from one another. These are the same tints the
 * Settings market tabs use, so a market looks the same wherever it appears.
 */
export const regionTone: Record<string, string> = {
  Houston: 'bg-sky-100 text-sky-900 dark:bg-sky-950 dark:text-sky-100',
  DFW: 'bg-violet-100 text-violet-900 dark:bg-violet-950 dark:text-violet-100',
  Memphis: 'bg-orange-100 text-orange-900 dark:bg-orange-950 dark:text-orange-100',
  Savannah: 'bg-teal-100 text-teal-900 dark:bg-teal-950 dark:text-teal-100',
  Charleston: 'bg-cyan-100 text-cyan-900 dark:bg-cyan-950 dark:text-cyan-100',
  Baltimore: 'bg-rose-100 text-rose-900 dark:bg-rose-950 dark:text-rose-100',
  Norfolk: 'bg-indigo-100 text-indigo-900 dark:bg-indigo-950 dark:text-indigo-100',
  Mobile: 'bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-100',
};

/** Surface for a market tile with no score.
 *
 * Deliberately NOT the market's own tint: rose, amber and teal sit in the same
 * hues as the red / yellow / green a scored tile uses, so a pale Baltimore
 * read as a bad day rather than an unconfigured one. A filled tile now always
 * means a score; neutral always means there is nothing to score.
 */
export const unscoredTone =
  'border border-theme-border-primary bg-slate-200/70 text-heading dark:bg-slate-800';

/** Surface for a container that belongs to one market, where no status colour
 *  competes with it -- the per-market sections of the Executive report. */
export const marketTone = (market: string) =>
  regionTone[market] ?? 'bg-theme-bg-secondary text-heading';
